document.addEventListener("DOMContentLoaded", function() {

// 1. Check if the body tag has the product template class
  // We check for both your specific class and the standard Shopify default just in case
  if (document.body.classList.contains('body-template-product') || document.body.classList.contains('template-product')) {
    
  // 2. Define your mapping of variant names to your uploaded PNG URLs
  const shapeIcons = {
    "Round": "https://cdn.shopify.com/s/files/1/0634/0263/9405/files/shape-round-sm.png?v=1783115030",
    "Oval": "https://cdn.shopify.com/s/files/1/0634/0263/9405/files/shape-oval-sm.png?v=1783115030",
    "Emerald": "https://cdn.shopify.com/s/files/1/0634/0263/9405/files/shape-emerald-sm.png?v=1783115030",
    "Marquise": "https://cdn.shopify.com/s/files/1/0634/0263/9405/files/shape-marquise-sm.png?v=1783115030",
    "Princess": "https://cdn.shopify.com/s/files/1/0634/0263/9405/files/shape-princess-sm.png?v=1783115030", 
	"Heart": "https://cdn.shopify.com/s/files/1/0634/0263/9405/files/shape-heart-sm.png?v=1783115030", 
	"Radiant": "https://cdn.shopify.com/s/files/1/0634/0263/9405/files/shape-radiant-sm.png?v=1783115030", 
	"Pear": "https://cdn.shopify.com/s/files/1/0634/0263/9405/files/shape-pear-sm.png?v=1783115030", 
  };

  // 3. Target the variant elements (you will need to adjust this selector based on your exact theme)
  // Looking at your screen, these look like button labels or radio label elements
  const variantLabels = document.querySelectorAll(".product-form__input label, .variant-input label");

  variantLabels.forEach(label => {
    //const text = label.textContent.trim();    
    const spanElement = label.querySelector("span:first-of-type");
    
    if(spanElement){
        const text = spanElement.textContent.trim();        
        //console.log('Text is: ' + text);

        // 4. If the text matches one of our shapes, inject the image
        if (shapeIcons[text]) {
          const img = document.createElement("img");
          img.src = shapeIcons[text];
          img.alt = text;
          img.style.display = "block";
          img.style.margin = "6px"; // 0 auto 5px auto 
          img.style.width = "40px";             
          img.style.height = "40px";

          label.insertBefore(img, spanElement);

          label.style.border = "1px solid #f0f0f0";
          label.style.margin = "6px 2px";
          label.style.padding = "48px 8px";          

          // New Flexbox rules for stacking
          label.style.display = "flex";
          label.style.flexDirection = "column";
          label.style.alignItems = "center";
          label.style.justifyContent = "center";
          label.style.gap = "8px";

          // Set width dynamically based on viewport size
          if (window.matchMedia("(max-width: 767px)").matches) {
            label.style.width = "75px";
          } else {
            label.style.width = "100px";
          }
        }
    }
    
    });
  }
});
 